import React from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

import { useLazyGetPlansQuery, billingApiSlice } from '../api/billingApiSlice';

const selectAvailablePlans = billingApiSlice.endpoints.getPlans.select();

function useSuggestedPlan() {
  const [getPlans] = useLazyGetPlansQuery();

  const availablePlans = useSelector(createSelector(selectAvailablePlans, (state) => state.data?.data));
  const suggestedPlan = React.useMemo(() => availablePlans?.find((plan) => plan.suggested), [availablePlans]);

  React.useEffect(() => {
    if (!availablePlans) {
      getPlans();
    }
  }, [availablePlans]);

  return suggestedPlan;
}

export default useSuggestedPlan;
